<template>
  <v-expand-transition appear>
    <ValidationProvider tag="div" class="overflow-hidden" :rules="rules" v-slot="{ errors }">

      <div class="text-h4 my-3" v-html="question.options.label[lang]"></div>

      <v-select v-model="inputValue"
                :error-messages="errors"
                class="pt-1 mb-6 mb-sm-8"
                :items="question.options.items[lang]"
                item-text="label"
                item-value="value"
                :multiple="question.options.multiple"
                :chips="question.options.chips"
                :return-object="question.options.returnObject"
                :deletable-chips="question.options.deletableChips"
                :hint="question.options.hint ? question.options.hint[lang] : ''"
                :placeholder="$t('component.select')"
                :persistent-hint="question.options.persistentHint"
                :outlined="question.options.outlined"
                :solo="question.options.solo"
                :clear-icon="question.options.clearIcon"
                :clearable="question.options.clearable"
                :hide-details="!question.options.persistentHint"
                flat
                :menu-props="{ maxHeight: 600, closeOnContentClick: true }"
                @change="setValue()"
      >
        <!--			<template v-slot:item="{ active, item, attrs, on }">-->
        <!--				<div v-html='item.label'></div>-->
        <!--			</template>-->
        <!--			<template v-slot:selection='{props, item, index}'>-->
        <!--				<v-chip :close="question.options.deletableChips"-->
        <!--				        @click:close="inputValue.splice(inputValue.indexOf(item), 1)" v-if="question.options.chips">-->
        <!--					<div v-html="item.label"></div>-->
        <!--				</v-chip>-->
        <!--				<span v-if="index >= 1 && !question.options.chips">{{ ',&nbsp;'}}</span><div v-if="!question.options.chips" v-html='item.label'></div>-->
        <!--			</template>-->
      </v-select>
    </ValidationProvider>
  </v-expand-transition>
</template>

<script>
import {ValidationProvider} from "vee-validate";
import AppStore from "../../../stores/AppStore";
import _ from "lodash";
import {EventBus} from "../../../services/Request";

export default {
  name: 'select-viewer',

  components: {
    ValidationProvider
  },

  props: {
    value: {
      type: [Object],
      default() {
        return {}
      }
    },
    questionIndex: {
      type: [Number],
      default: 0
    },
    lang: {
      type: [String],
      default: 'fr'
    },
    rules: {
      type: [Object, String],
      default: ""
    },
  },

  data: () => ({
    inputValue: ""
  }),

  mounted() {

  },

  created() {
    if (!_.isEmpty(AppStore.rating.questions_answers) && AppStore.rating.questions_answers[this.question.id]) {
      this.inputValue = AppStore.rating.questions_answers[this.question.id].content
    }
  },

  computed: {
    question: {
      get() {
        return this.value;
      },

      set(newValue) {
        this.$emit('input', newValue)
      }
    },
  },

  watch: {},

  methods: {
    setValue() {
      EventBus.$emit('setQuestionAnswer', {
        question: this.question,
        inputValue: this.inputValue,
      })
    }
  }
};
</script>
<style>
.v-select i {
  font-size: 1.8rem !important;
}
</style>